import { inject, Injectable, signal } from "@angular/core";

import { ViewsBaseFilter } from "@bitwarden/web-vault/app/gloss/views/views-control/views-customize/views-base.filter";
import { CalculationPastStoreService } from "@bitwarden/web-vault/app/services/store/calculation-past/calculation-past.store.service";
import {
  CategoryFilter,
  CountryFilter,
  MainFilter,
  PastMainFilterType,
} from "@bitwarden/web-vault/app/models/types/filter.types";
import { Observable } from "rxjs";
import { toObservable } from "@angular/core/rxjs-interop";

@Injectable({
  providedIn: "root",
})
export class ViewsPastFilter extends ViewsBaseFilter {
  filter = signal<MainFilter<PastMainFilterType>>(null);
  filterObservable$: Observable<MainFilter<PastMainFilterType>> = toObservable(this.filter);

  constructor() {
    const calculationPastStoreService = inject(CalculationPastStoreService);
    super(calculationPastStoreService);
  }

  onCategorySelect(selectedCatIds: string[]) {
    this.selected.categories = selectedCatIds;
    this.setFilter();
  }

  override setFilter() {
    const countryMap = this.createCountryFilter();

    const categoryMap: Map<string, CategoryFilter> = new Map();
    for (const categoryId of this.options.categories) {
      const categoryView = this.userStore.categories
        .categoryViews()
        .find((cv) => cv.id === categoryId);
      const isSelectedCategory = this.selected.categories.includes(categoryId);
      const categoryFilter: CategoryFilter = {
        view: categoryView,
        isDisabled: false,
        isSelected: isSelectedCategory,
      };
      categoryMap.set(categoryId, categoryFilter);
    }
    const filter: MainFilter<PastMainFilterType> = {
      countryFilter: countryMap,
      categoryFilter: categoryMap,
    };
    this.filter.set(filter);
  }
}
